import React from 'react';
import { inject, observer } from 'mobx-react';
import H5VoteList from './h5';
import PCVoteList from './pc';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';

interface VoteListProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    threadData?: any;   // 帖子数据
    votesData: any
    // question: string;
    // options: any;
    // mode?: 'single' | 'multiple';
    onSubmit?: any;
    initialSelected?: any;
    submitButtonText?: string;
    // theme?: 'default' | 'dark';
    hasVoted?: boolean; // 是否已投票
    totalVotes?: number; // 总票数
    endAt?: any // 截止时间
    onVoteChange?: (selected: string[]) => void; // 选择变化回调
}

@inject('app', 'site', 'user')
@observer
class VoteList extends React.Component<VoteListProps> {
    componentDidMount() {
        // 可以在这里添加初始化逻辑
        // console.log('组件组件');
    }

    

    render() {
        const { site, app, votesData, onSubmit, ...props } = this.props;
        const platform = app?.platform || 'h5';
        if (platform === 'pc') {
            return <PCVoteList onSubmit={onSubmit} votesData={votesData} {...props}/>;
        } else {
            return <H5VoteList onSubmit={onSubmit} votesData={votesData} {...props} />;
        }
        
        
    }
}

export default VoteList;